module.exports = __webpack_public_path__ + "img/laptop-screen.50fb0d46.png";